import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Scale } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    // Precisa bater exatamente com o placeholder estático "#root-boot" do index.html
    // (mesmo fundo stone-950, mesmo dourado) — antes disso aqui usava bg-stone-50 (quase
    // branco) com ícone cinza-claro, então no instante em que o React montava e assumia o
    // lugar do placeholder estático a tela "piscava" de escura pra branca (percebido como
    // tela em branco) e a balança, antes dourada sobre fundo escuro, virava um ícone cinza
    // claro de baixo contraste — parecendo ter sumido. Lote 50.
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-950">
        <Scale
          className="w-14 h-14 animate-pulse text-[#c9a15a]"
          strokeWidth={1.25}
          style={{ animationDuration: "0.85s" }}
        />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  // Lote 87: cadastro incompleto (CPF, OAB) ou Termo sem aceite da versão atual → tela de aceite.
  if (user.onboarding_required && location.pathname !== "/aceite") return <Navigate to="/aceite" replace />;
  return children;
}
